/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PayrollViewerControllerGetViewer200ResponseDataWarningsInner { 
    code?: PayrollViewerControllerGetViewer200ResponseDataWarningsInner.CodeEnum;
    detail?: string;
}
export namespace PayrollViewerControllerGetViewer200ResponseDataWarningsInner {
    export type CodeEnum = 'UNMAPPED_CONCEPT' | 'INCOMPLETE_PERIOD' | 'ZERO_PAYROLL' | 'NSS_MISMATCH';
    export const CodeEnum = {
        UnmappedConcept: 'UNMAPPED_CONCEPT' as CodeEnum,
        IncompletePeriod: 'INCOMPLETE_PERIOD' as CodeEnum,
        ZeroPayroll: 'ZERO_PAYROLL' as CodeEnum,
        NssMismatch: 'NSS_MISMATCH' as CodeEnum
    };
}


